<div class="intro-line-1">Validation and verification</div>

@if (client && inputFields.length > 0) {
  <client-header [headerLabel]="'Customer account validation'" [headerGroup]="'onboarding'" (click)="headerGroups.validation = !headerGroups.validation"></client-header>
  @if (headerGroups.validation) {
    <div class="collapse-container">
      <app-onboarding-toggle [btnLabel]="client.feed_enabled ? 'Enable customer validation' :'Will there be customer validation?'" [btnName]="'validation_enabled'"
      [(btnModel)]="client.validation.enabled"></app-onboarding-toggle>
      <p class="helper-text">Customer validation is used by Relay Hosted Onboarding services to determine that a potential customer is in your system.</p>
      @if (client.validation.enabled === 'true') {
        <div class="select-container">
          <label>Location of customer lookup</label>
          <select class="form-control" [(ngModel)]="client.validation.customer_lookup_location">
            <option value="db"  [attr.selected]="client.validation.customer_lookup_location === 'db' ? true : null">DB/CCA File</option>
            <option value="web" [attr.selected]="client.validation.customer_lookup_location === 'web' ? true : null">Web Service</option>
          </select>
        </div>
        <div class="select-container">
          <label>Primary Customer Validation</label>
          <p class="helper-text">Think of this as your customers account number, account ID, or member ID. The value should be known to your customers as it will be required to onboard.</p>
          <select class="form-control" [(ngModel)]="client.validation.look_up_by_secondary_account_id">
            <option [ngValue]="false" [attr.selected]="client.validation.look_up_by_secondary_account_id === false ? true : null">CCID</option>
            <option [ngValue]="true" [attr.selected]="client.validation.look_up_by_secondary_account_id === true ? true : null">Secondary ID</option>
          </select>
        </div>
        <div class="select-container">
          <label>Maximum number of attempts</label>
          <input id="max-attempts-field" class="form-control" type="number" min="0" max="99" [value]="client.validation.max_attempts" (change)="onValidationMaxAttemptChange($event)"/>
        </div>
        <div class="fields-container">
          <label>Information fields</label>
          <p class="helper-text">These fields will be displayed to CSRs when they've selected an experience trigger that <strong>does not require</strong> validation.  All fields will be optional.</p>
          <rn-validation-fields-list
            [allFields]="inputFields"
            [selectedFields]="client.validation.information_fields | clone "
            (listChanged)="informationFieldsListChanged($event)">
          </rn-validation-fields-list>
        </div>
        <div class="fields-container">
          <label>Validation fields</label>
          <p class="helper-text">These fields will be displayed to CSRs when they've selected an experience trigger that <strong>requires</strong> validation.  All fields will be required.</p>
          <rn-validation-fields-list
            [allFields]="inputFields"
            [selectedFields]="client.validation.fields | clone"
            (listChanged)="validationFieldsListChanged($event)">
          </rn-validation-fields-list>
        </div>
      }
    </div>
  }
  @if (client.feed_enabled) {
    <client-header id="password-settings-header" [headerLabel]="'Password settings'" [headerGroup]="'onboarding'" (click)="headerGroups.passwordSettings = !headerGroups.passwordSettings"></client-header>
    @if (headerGroups.passwordSettings) {
      <div class="collapse-container">
        <app-radio-btn
          [btnLabel]="'Enfore password rotation'"
          [btnWidth]="'900px'"
          [btnName]="'enfore-password-rotation'"
          [btnModel]="client.password_configuration.rotation_enabled"
          (btnModelChange)="toggleEnforcePasswordRotation()"
          >
        </app-radio-btn>
        <p class="helper-text">Customers will be required to set a new password at a determined frequency.</p>
        <!-- only visible when password rotation is ON -->
        @if (client.password_configuration.rotation_enabled) {
          <label for="rotation-interval-select">Rotation Frequency</label>
          <select
            id="rotation-interval-select"
            name="rotation-interval-select"
            class="form-control rotation-interval-select"
            (change)="changeRotationFrequency($event)"
            >
            @for (rotationOption of rotationIntervalOptions; track rotationOption) {
              <option
                [value]="rotationOption.value"
                [selected]="client.password_configuration.rotation_interval === rotationOption.value"
                >
                {{rotationOption.label}}
              </option>
            }
          </select>
        }
      </div>
    }
  }
  <!-- DIS-1762. Deliberately outside the feed_enabled block above: the portal
       session window applies to the client portal regardless of Feed. Access is
       already restricted by the client-config route's cs:client:edit
       requirement, which only Relay internal roles hold. -->
  <client-header id="session-settings-header" [headerLabel]="'Portal session'" [headerGroup]="'onboarding'" (click)="headerGroups.sessionSettings = !headerGroups.sessionSettings"></client-header>
  @if (headerGroups.sessionSettings) {
    <div class="collapse-container">
      <label for="session-timeout-select">Session timeout</label>
      <select
        id="session-timeout-select"
        name="session-timeout-select"
        class="form-control rotation-interval-select"
        (change)="changeSessionTimeout($event)"
        >
        @for (timeoutOption of sessionTimeoutOptions; track timeoutOption.label) {
          <option
            [value]="timeoutOption.value"
            [selected]="client.portal_session_timeout_minutes === timeoutOption.value"
            >
            {{timeoutOption.label}}
          </option>
        }
      </select>
      <p class="helper-text">Portal users of this client are signed out after this much inactivity. They are warned five minutes beforehand and can choose to stay signed in. Relay staff keep their own session length.</p>
    </div>
  }
  <client-header [headerLabel]="'Mobile message verification'" [headerGroup]="'onboarding'" (click)="headerGroups.verification = !headerGroups.verification"></client-header>
  @if (headerGroups.verification) {
    <div class="collapse-container">
      <app-client-mobile-message-verification [client]="client" [allFields]="inputFields"></app-client-mobile-message-verification>
    </div>
  }
}

<div class="button-container clearfix">
  <button id="prev-btn" class="btn btn-primary btn-with-icon" (click)="previousStep()">
    <span class="icon icon-left">
      <i class="fa fa-arrow-left"></i>
    </span>
    <span class="btn-label">Previous</span>
  </button>
  <button class="btn btn-primary" id="next-btn" (click)="saveAndContinue()" [class.inactive]="checkDisabled()" [disabled]="checkDisabled()">
    <span i18n="Label for Next button on new client configuration" id="save-and-next-button">
      Save And Next
    </span>
    <span class="icon icon-right">
      <i class="fa fa-arrow-right"></i>
    </span>
  </button>
</div>

<message-dialog></message-dialog>
